import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/leads/artifacts/new")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/artifacts/new", search, replace: true });
    },
});
